import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [profilePic, setProfilePic] = useState(localStorage.getItem("profilePic") || null);
  const [availabilityStatus, setAvailabilityStatus] = useState(localStorage.getItem("availability") || null);

  useEffect(() => {
    const stored = localStorage.getItem("profilePic");
    if (stored) setProfilePic(stored);

    const availabilityStored = localStorage.getItem("availability");
    if (availabilityStored) setAvailabilityStatus(availabilityStored);
  }, []);

  return (
    <UserContext.Provider
      value={{
        profilePic,
        setProfilePic,
        availabilityStatus,
        setAvailabilityStatus,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
